"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = UploadedSources;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_native_1 = require("react-native");
const useDevice_1 = require("../../hooks/useDevice");
const ChatImage_1 = __importDefault(require("./ChatImage"));
const ScrollCustomIndicator_1 = __importDefault(require("../ScrollCustomIndicator"));
const ChatFile_1 = __importDefault(require("./ChatFile"));
;
function UploadedSources({ sources, onCloseSource, ...restProps }) {
    const { isMobileScreen } = (0, useDevice_1.useDevice)();
    return sources.length > 0 && ((0, jsx_runtime_1.jsx)(ScrollCustomIndicator_1.default, { customIndicator: !isMobileScreen, horizontal: true, contentContainerStyle: styles.thumbnailCarousel, ...restProps, children: sources.map((uploadedSource) => (uploadedSource.type === 'image' ? ((0, jsx_runtime_1.jsx)(ChatImage_1.default, { source: uploadedSource.url, thumbnail: true, onClose: () => onCloseSource?.(uploadedSource.url) }, uploadedSource.url)) : ((0, jsx_runtime_1.jsx)(ChatFile_1.default, { name: uploadedSource.name, source: uploadedSource.url, thumbnail: true, onClose: () => onCloseSource?.(uploadedSource.url) }, uploadedSource.url)))) }));
}
;
const styles = react_native_1.StyleSheet.create({
    thumbnailCarousel: {
        gap: 8,
        alignItems: 'center',
        marginVertical: 8,
        marginLeft: 8,
    },
});
